import { Hexagon } from "lucide-react";

export default function FoundersStory() {
  return (
    <section
      id="spy-founders"
      className="relative max-w-5xl mx-auto px-6 py-24 sm:py-32"
      data-testid="landing-founders"
    >
      <div className="grid lg:grid-cols-5 gap-10 items-center">
        <div className="lg:col-span-2">
          <div className="relative aspect-square rounded-3xl bg-gradient-to-br from-amber-100 via-amber-50 to-yellow-50 border border-amber-200 overflow-hidden grid place-items-center">
            <div className="absolute inset-0 opacity-20 pointer-events-none">
              <Hexagon className="absolute -top-6 -left-6 w-44 h-44 text-amber-300" strokeWidth={1} />
              <Hexagon className="absolute -bottom-10 -right-8 w-56 h-56 text-amber-400" strokeWidth={1} />
            </div>
            <div className="relative text-center px-6">
              <Hexagon className="w-16 h-16 text-amber-700 mx-auto" strokeWidth={1.5} />
              <div className="font-display text-2xl font-light text-stone-900 mt-3">Hive @ Buzzzillion</div>
              <div className="text-xs uppercase tracking-[0.2em] text-amber-700 mt-1 font-semibold">Built by beekeepers</div>
            </div>
          </div>
        </div>
        <div className="lg:col-span-3 space-y-4">
          <div className="text-xs font-semibold uppercase tracking-[0.25em] text-amber-700">Our story</div>
          <h2 className="font-display text-3xl sm:text-4xl font-light tracking-tight text-stone-900 leading-tight">
            I started this after losing a hive to varroa because my paper notebook got rained on.
          </h2>
          <p className="text-stone-700 leading-relaxed">
            One spring I'd been tracking three colonies in a soft-cover field book — counts, dates, weights, all of it. A short shower during a yard visit smudged half a season's worth of notes. By the time I caught up on what I couldn't read, one hive had crashed from a mite infestation I'd missed by ten days.
          </p>
          <p className="text-stone-700 leading-relaxed">
            We built Hive @ Buzzzillion as the tool we wished we had then: <strong className="text-stone-900">capture inspections in seconds, see trends over months, get nudged before things go wrong.</strong> No more lost notes, no more guessing whether you treated for mites this year, no more end-of-season "where did all the honey go?"
          </p>
          <p className="text-stone-700 leading-relaxed">
            Every feature you'll see here exists because a real beekeeper — usually us, sometimes you — opened a hive one Saturday morning and thought: <em>I wish my logbook could do this.</em>
          </p>
          <div className="pt-3 text-sm text-stone-500">
            — The Hive @ Buzzzillion team
          </div>
        </div>
      </div>
    </section>
  );
}
